import React, { useEffect, useState } from "react";
import { Header } from "../../components/Header/Header";
import { Navigator } from "../../components/Navigator/Navigator";
import { List } from "../../components/List/List";
import { NewWithInfo } from "../../components/New/NewWithInfo";
import illustration from "../../assets/Home/Illustration.png";
import plusIcon from "../../assets/Home/icon-plus.svg";
import { useAuth } from "../../context/AuthContext";
import { NemuContext } from "../../utils/NemuContext";
import { EditDevelopment } from "../../components/EditDevelopment/EditDevelopment";
import { api } from "../../context/Auth";
import axios from "axios";

function MyProjects() {
  const { selectedProp, setSelectedProp } = React.useContext(NemuContext);
  const [selectedProject, setSelectedProject] = useState(null);
  const [developmentData, setDevelopmentData] = useState(null);
  const [loadingDevelopmentData, setLoadingDevelopmentData] = useState(true);
  const [showNew, setShowNew] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isCreatingDraft, setIsCreatingDraft] = useState(false);
  const { user, myProjects, createDraftProject } = useAuth();

  const fetchDevelopment = async () => {
    if (selectedProp === 0) return; // Si no hay un proyecto seleccionado, no hacemos la consulta
    setLoadingDevelopmentData(true);
    try {
      const response = await axios.get(`${api}/development/allData/${selectedProp}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // console.log("Response:", response);
      
      if(response.data.success) {
        setDevelopmentData(response.data.data);
      }
      else{
        console.log("Error fetching development data:", response.data.message);
      }
    }catch (error) {
      console.error("Error fetching development data:", error);
      setError("Error al cargar los datos del desarrollo");
    }
    finally {
      setLoadingDevelopmentData(false);
    }
  };

  useEffect(() => {
      fetchDevelopment();
  }, [selectedProp]);

  useEffect(() => {
    if (myProjects) {
      try {
        setLoading(false);
        // Solo ordenamos y seleccionamos si no hay un proyecto seleccionado
        if (!selectedProp && myProjects.length >= 1) {
          const sortedProjects = [...myProjects].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setSelectedProp(sortedProjects[0].id);
        }
        
      } catch (err) {
        console.error("Error processing projects:", err);
        setError("Error al procesar los proyectos");
      }
    }
  }, [myProjects]);

  const createDraft = async (userId) => {
    if (isCreatingDraft) return; // Prevenir múltiples clicks

    try {
      setIsCreatingDraft(true);
      setError(null);
      
      const response = await createDraftProject(userId);
      
      if (!response?.developments?.id) {
        throw new Error("No se pudo crear el proyecto");
      }
      
      setSelectedProp(response.developments.id);
      setShowNew(true);
    } catch (err) {
      console.error("Error creating draft project:", err);
      setError("No se pudo crear el proyecto. Por favor, intenta de nuevo.");
    } finally {
      setIsCreatingDraft(false);
    }
  };

  useEffect(() => {
    if (selectedProp) {
      const selectedProject = myProjects.find(
        (project) => project.id === selectedProp
      );
      setSelectedProject(selectedProject);
    }
  }, [selectedProp, myProjects]);

  if (loading) {
    return (
      <main className="w-[100svw] h-[100%] max-w-[100svw] bg-[#eaeaea]">
        <Header />
        <div className="flex justify-center items-center h-[100svh]">
          Cargando...
        </div> 
      </main>
    );
  }

  return (
    <main className="w-[100svw] max-w-[100svw] bg-[#eaeaea]">
      <Header />
      <div className="flex w-[calc(100svw - 20px)] pr-[20px] pb-[20px]">
        <Navigator />
        {error && (
          <div className="absolute top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
            {error}
          </div>
        )}
        
        {myProjects.length > 0 && selectedProject ? (
          <div className="flex w-full h-[calc(100svh-120px)] gap-[10px]">
            <List projects={myProjects} />
              {selectedProp === null ? (
                <div className="flex justify-center items-center w-full h-full bg-slate-300">
                  Selecciona un proyecto
                </div>
              ) : loadingDevelopmentData ? (
                <div className="flex justify-center items-center w-full h-full bg-slate-300">
                  Cargando datos del desarrollo...
                </div>
              ) : (
                <EditDevelopment development={developmentData} onSaveSuccess={fetchDevelopment}/>
              )}
          </div>
        ) : (
          <div className={`${showNew ? "hidden" : "flex w-full h-full justify-center items-center bg-slate-300"}`}>
            <div className="flex flex-col w-[30svw] justify-center items-center gap-[8px]">
              <img className="w-[90%]" src={illustration} alt="Illustration" />
              <h3 onClick={() => console.log(myProjects)} className="text-[23px]">Tu portafolio de propiedades está vacío</h3>
              <p className="text-[15px] px-[20px] text-center">
                Haz clic en el botón "Nuevo Proyecto" para comenzar a crear y gestionar tus inmuebles.
              </p>
              <button
                onClick={() => createDraft(user.id)}
                disabled={isCreatingDraft}
                className="flex w-auto h-[100%] gap-[8px] justify-center cursor-pointer bg-nemu-azul rounded-[4px] px-[16px] py-[8px] disabled:opacity-50"
              >
                <img src={plusIcon} alt="Plus Icon" />
                <p className="text-white">
                  {isCreatingDraft ? "Creando..." : "Nuevo Proyecto"}
                </p>
              </button>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}

export { MyProjects };